/**
 * Pipeline (Kanban board) types for job search tracking.
 * Jobs move through stages: Saved -> Applied -> Interview -> Offer / Rejected
 */

export type PipelineStatus = 'saved' | 'applied' | 'interview' | 'offer' | 'rejected';

export interface PipelineJob {
  id: string;
  vacancyId: string;
  title: string;
  company: string;
  location?: string;
  source?: string;
  status: PipelineStatus;
  matchScore: number;
  addedAt: string;           // ISO date
  appliedAt?: string;        // ISO date, set when moved to 'applied'
  interviewAt?: string;      // ISO date, set when moved to 'interview'
  notes: string;
  generatedCVId?: string;
  coverLetterId?: string;
  url?: string;
  description?: string;
}

export interface PipelineColumn {
  id: PipelineStatus;
  title: string;
  color: string;             // CSS variable name
  jobs: PipelineJob[];
}

export interface PipelineFilters {
  search: string;
  minScore: number;
  source: string;
  status: PipelineStatus | 'all';
}

export const PIPELINE_COLUMNS: { id: PipelineStatus; title: string; color: string }[] = [
  { id: 'saved', title: 'Saved', color: 'var(--color-text-secondary)' },
  { id: 'applied', title: 'Applied', color: 'var(--color-primary)' },
  { id: 'interview', title: 'Interview', color: 'var(--color-warning)' },
  { id: 'offer', title: 'Offer', color: 'var(--color-success)' },
  { id: 'rejected', title: 'Rejected', color: 'var(--color-error)' },
];

export const DEFAULT_PIPELINE_FILTERS: PipelineFilters = {
  search: '',
  minScore: 0,
  source: '',
  status: 'all',
};
